import { FormlyFieldConfig } from "@ngx-formly/core";
import { LinkDownload } from "app/formly/link-download.type";
import { AllegatiBolliAltroStep } from "../../shared/allegati-bolli-altro.step";

export const AllegatiManifestazioneStep: FormlyFieldConfig[] = [
    {
      "props": { "label": 'ALLEGATI ' },
      "fieldGroup": [
        {
          "key": 'allegati_pareri',
          "type": 'mat-upload',
          "props": {
            "label": "PARERI / NULLA OSTA",
            "multiple": true,
          }
        },
      ]
    },
  ]
